import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import Publications from "@/pages/Publications";
import Submission from "@/pages/Submission";
import Directors from "@/pages/Directors";
import Contact from "@/pages/Contact";
import Services from "@/pages/Services";
import ReviewPanel from "@/pages/ReviewPanel";
import PreWrittenContent from "@/pages/PreWrittenContent";
import ContentWritingServices from "@/pages/ContentWritingServices";
import IndexedPublications from "@/pages/IndexedPublications";
import APIScoreGuide from "@/pages/APIScoreGuide";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/companies/:slug" element={<CompanyDetail />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/submission" element={<Submission />} />
            <Route path="/directors" element={<Directors />} />
            <Route path="/services" element={<Services />} />
            <Route path="/review-panel" element={<ReviewPanel />} />
            <Route path="/pre-written-content" element={<PreWrittenContent />} />
            <Route path="/content-writing-services" element={<ContentWritingServices />} />
            <Route path="/indexed-publications" element={<IndexedPublications />} />
            <Route path="/academic-performance-indicator" element={<APIScoreGuide />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
